import BaseService from './base-service';
import {serialize, serializeArray} from '../helpers/request';
import config from 'src/config/index.js';
import axios from 'axios';

export default class PositionService extends BaseService {
    constructor() {
        super('positions');
    }

    getPositionsByIds = (ids) => {
        return this.__get(`positions?${serializeArray({id: ids})}`);
    };

    getPositionsFromTo = (deviceId, from, to) => {
        return this.__get( `positions?${serialize(Object.assign({_dc: new Date().getTime()}, {deviceId, from, to}))}`);
    };

    async pushOsmAndPosition({
        deviceUniqueId,
        lat,
        lon,
    }) {
        const freshHttpClient = axios.create({
            baseURL: config.OSM_AND_BASE_URL,
        });
        await freshHttpClient.request({
            method: 'GET',
            url: '',
            params: {
                id: deviceUniqueId,
                timestamp: Date.now(),
                lat,
                lon,
            },
        }).catch((_) => {
            // do nothing, just avoid CORS
            // check this https://www.traccar.org/forums/topic/cors-osmand-response-not-using-config-of-weborigin/ later
        });
    }
}
